import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"


const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const getUserQuizAction = createAsyncThunk(
    'get-user-quiz',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/users/api/my-quiz-history`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getUserQuizlice = createSlice({
    name: 'get-user-quiz',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getUserQuizAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getUserQuizAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(getUserQuizAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const getUserQuizReducer = getUserQuizlice.reducer